import { mountSelectorAt } from 'utils/selectors';

const mount = mountSelectorAt('links');

export const getLinks = mount(localState => localState);




/** WEBPACK FOOTER **
 ** ./src/members/state/links/selectors.js
 **/